export default "__VITE_ASSET__slv8toMp__"